export default "__VITE_ASSET__CavNA9gU__"